import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Modal as Modal$1 } from '@mui/material';
import { styled } from '@mui/material/styles';
import { shouldNotForwardProps, spacing } from '../../foundation/utils.js';
import '../assist-chip/assist-chip.js';
import '../button/button.js';
import '../card/card.js';
import '../checkbox/checkbox.js';
import '@mui/system';
import '../container/container.js';
import '../dialog/dialog.js';
import '../divider/divider.js';
import '../donut/donut.js';
import '@mui/icons-material/ArrowBack';
import '@mui/material/Drawer';
import '@mui/icons-material/ContentCopyRounded';
import '../fast-copy/fast-copy.types.js';
import '../feedback-banner/feedback-banner.js';
import '../filter-chip-select/filter-chip-select.js';
import '../filter-chip/filter-chip.js';
import '../line/line.js';
import '../link/link.js';
import '../logo/logo.js';
import '../menu-list/menu-list.js';
import 'core-js/modules/es.parse-int.js';
import 'react';
import '../pagination/pagination.types.js';
import '../popover/popover.js';
import '../radio/radio.js';
import '../../foundation/theme/theme.js';
import '../select/select.js';
import '../snackbar/snackbar.js';
import '../snackbar/snackbar.types.js';
import { Stack } from '../stack/stack.js';
import '../stats/stats.js';
import '../stats/stats.types.js';
import '../switch/switch.js';
import '../table/table.js';
import '../table/table.types.js';
import '../tabs/tabs.js';
import '../tag/tag.js';
import '../tag/tag.types.js';
import '../text-field/text-field.js';
import '../text/text.js';
import '../tooltip/tooltip.js';
import { Content } from './content.js';

let _ = t => t,
  _t,
  _t2;
const Overlay = styled(Modal$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _``));
const CloseIcon = styled(CloseOutlinedIcon)(_t2 || (_t2 = _`
  position: absolute;
  right: ${0};
  top: ${0};
  cursor: pointer;
`), spacing(10), spacing(10));
const ModalActions = ({
  children,
  align: _align = 'right'
}) => jsx(Stack, Object.assign({
  marginTop: 9,
  flexDirection: "row",
  justifyContent: _align
}, {
  children: children
}));
const ModalTitle = ({
  children
}) => jsx(Stack, Object.assign({
  marginBottom: 3,
  flexDirection: "row"
}, {
  children: children
}));
const ModalDescription = ({
  children
}) => jsx(Stack, Object.assign({
  flexDirection: "row"
}, {
  children: children
}));
const ModalContent = ({
  children
}) => jsx(Stack, Object.assign({
  marginTop: 6,
  flexDirection: "row"
}, {
  children: children
}));
const Modal = _a => {
  var {
      children,
      close
    } = _a,
    props = __rest(_a, ["children", "close"]);
  return jsx(Overlay, Object.assign({}, props, {
    children: jsxs(Content, Object.assign({
      size: props.size,
      overflow: props.overflow
    }, {
      children: [close && jsx(CloseIcon, {
        onClick: close
      }), children]
    }))
  }));
};

export { Modal, ModalActions, ModalContent, ModalDescription, ModalTitle };
